import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import Facebook from 'containers/SocialLogin/Facebook/Facebook';
import Twitter from 'containers/SocialLogin/Twitter/Twitter';
import LinkedIn from 'containers/SocialLogin/LinkedIn/LinkedIn';
import Google from 'containers/SocialLogin/Google/Google';
import { grabFromLocalStorage, facebook_get_access_token_api, HeaderConfig, user_Registration, twitter_api } from 'Api/Api';
import './style.css';
import Button from 'components/Button/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logo from 'Assets/loginLogo.svg';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import axios from 'axios';
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup';
import { saveKey } from "../../../../utils/Helper";
import Footer from 'components/Footer/Footer';
import { origin } from 'utils/Helper';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner'
import { getQueryString } from "utils/Helper";
import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

class Register extends Component {
    static contextType = UserContext;
    
    constructor(props) {
        super(props);
        this.state = {
            Auth_Res: '',
            user: null,
            type: 'password',
            wording: <i className="fa fa-eye"></i>,
            value: '',
            email: null,
            password: null,
            ModalLoader: false,
            loader: true,
            errors: {
                email: '',
                password: '',
            },
            validated: false,
            InvalidMsg: 0,
        };
        
        
    }


    // getUserFbData will facebook_get_access_token_api 
    getUserFbData = (userData) => {
        let resData = userData[0];
        let access_obj = { "access_token": resData.accessToken }
        const Json_access_Obj = JSON.stringify(access_obj);
        axios.post(facebook_get_access_token_api, Json_access_Obj, HeaderConfig)
            .then((response) => {
                let UserData = { "UserMail": resData.email, "login_Auth_Res": response.data, }
                saveKey("UserData", JSON.stringify(UserData));
                grabFromLocalStorage();
                window.location.href = origin;
            })
            .catch(() => {
            });
    }

    // getUserTwitterData will Twitter_get_access_token_api
    getUserTwitterData = () => {
        window.location.href = origin;
    }

    componentDidMount() {
        this.context.setUserInfo({});
        this.setState({ loader: true })
        const oauth_token = getQueryString('oauth_token');
        const oauth_verifier = getQueryString('oauth_verifier');
        if (oauth_token && oauth_verifier) {
            this.setState({ loader: true })
            axios.post(twitter_api, { oauth_token, oauth_verifier }, HeaderConfig)
                .then(response => {
                    let data2 = { "UserMail": "", "login_Auth_Res": response.data }
                    saveKey("UserData", JSON.stringify(data2));
                    grabFromLocalStorage();
                    window.location.href = origin;
                })
                .then(({ data = {} }) => {
                    if (Object.keys(data)) {
                        this.setState({ loader: false })
                        window.location.href = origin;
                    }
                })
                .catch(() => {
                    this.setState({ loader: false })
                });
        }
        else {
            this.setState({ loader: false })
        }
    }


    // changeState is for password toggle validation.
    changeState = () => {
        var oldState = this.state.type;
        var isTextOrHide = (oldState === 'password');
        var newState = (isTextOrHide) ? 'text' : 'password';
        var newWord = (isTextOrHide) ? <i className="fa fa-eye-slash" aria-hidden="true"></i> : <i className="fa fa-eye"></i>;
        this.setState({
            type: newState,
            wording: newWord
        })
    }
//  Form Validation
    myChangeHandler = (event) => {
        if (event.target.id === "validationEmail") {
            this.setState({ email: event.target.value })
        }
        else if (event.target.id === "validationPassword") {
            this.setState({ password: event.target.value })
        }
    }
// Form Submit Data
    handleSubmitData = event => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else if (form.checkValidity() !== false) {
            event.preventDefault();
            const { email, password } = this.state;
            this.setState({ ModalLoader: true })
            let loginData = { "email": email, "password": password }
            axios.post(user_Registration, loginData, HeaderConfig)
                .then((response) => {
                    this.setState({ ModalLoader: false, InvalidMsg: 0, })
                    let UserData = { "UserMail": email, "login_Auth_Res": response.data, }
                    saveKey("UserData", JSON.stringify(UserData));
                    grabFromLocalStorage();
                    window.location.href = origin;
                    //this.props.history.push({
                        //pathname: '/aboutyourself',
                        
                        //state: { accessToken: response.data }
                    //})
                    // window.location.href = "https://pechakucha-front.armentum.co/";
                })
                .catch(() => {
                    this.setState({ ModalLoader: false, InvalidMsg: 1, })
                });
        }
        this.setState({ validated: true })
    };

    LoginPK = () => {
        this.props.history.push("/login");
    }

    render() {
        const { ModalLoader ,loader} = this.state;
        if (loader) {
            return (
                <FullPageSpinner />
            )
        }
        else {
            return (
                <React.Fragment>
                <Helmet>
                    <title>PechaKucha Register</title>
                    <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <div className="login-footer">
                    <div className="Register-grid">
                        <Row className="nomargin flex-center" >
                            <Col lg={2} md sm />
                            <Col lg={8}>
                                <div className="flex-center logo-container">
                                    <a href="/"><img src={logo} alt="img" className="img-fluid navbar-brand img-logo" /></a>
                                </div>
                                <div className="Register-Form">
                                    <Row>
                                        {/* <Col lg={1} xsHidden /> */}
                                        <Col xl={5} lg={6} md={6} sm={6} xs={12} className="noPadding pad-l">
                                            <div className="Register-body">
                                                <p>Create an Account</p>
                                                <div className="social-login">
                                                    <div className="twitter">
                                                        <Twitter {...this.props} callbackUrl="/login" ongetUserTwitterData={this.getUserTwitterData} />
                                                    </div>
                                                    <div className="facebook">
                                                        <Facebook ongetUserFbData={this.getUserFbData} />
                                                    </div>
                                                    <div className="linkedin">
                                                        <LinkedIn />
                                                    </div>
                                                   <div className="google">
                                                        <Google />
                                                    </div>
                                                </div>
                                                {/* Border */}
                                                <div className="border-style"></div>
                                                <div className="Form-section">
                                                    <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmitData}>
                                                        <Form.Row>
                                                            <Form.Group as={Col} md="12" controlId="validationEmail">
                                                                <Form.Label>E-MAIL ADDRESS</Form.Label>
                                                                <Form.Control
                                                                    required
                                                                    type="email"
                                                                    placeholder="Enter your email"
                                                                    onChange={this.myChangeHandler}
                                                                />
                                                            </Form.Group>
                                                        </Form.Row>
                                                        <Form.Row>
                                                            <Form.Group as={Col} md="12" controlId="validationPassword">
                                                                <Form.Label>PASSWORD
                                                            <InputGroup>
                                                                        <Form.Control
                                                                            type={this.state.type}
                                                                            placeholder="Enter your password"
                                                                            aria-describedby="inputGroupPrepend"
                                                                            required
                                                                            onChange={this.myChangeHandler}
                                                                        />
                                                                        <span className="password-trigger" onClick={this.changeState}>{this.state.wording}</span>
                                                                    </InputGroup>
                                                                </Form.Label>
                                                            </Form.Group>
                                                        </Form.Row>
                                                        <div style={{ display: this.state.InvalidMsg === 0 ? "none" : null }} className="Invalid-section">
                                                            <span className="Invalid-Msg">Invalid Username/Password</span>
                                                        </div>
                                                        <div>
                                                            {
                                                                ModalLoader === false ?
                                                                    <Button theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5">Join the Community</Button>
                                                                    :
                                                                    <ActivityIndicator theme="button-Status-Loader" />
                                                            }
                                                        </div>
                                                    </Form>
                                                </div>
                                                {/* Border */}
                                                <div className="border-style"></div>
                                                <Button theme="btn-global btn-white width100 Form_Btn_Pad font-normal" OnClickMet={this.LoginPK}>Have an account? Login</Button>
                                            </div>
                                        </Col>
                                        <Col xl={7} lg={6} md={6} sm={6} className="noPadding d-none d-lg-block d-md-block d-sm-block d-xs-none pad-r" >
                                            <div className="Register-Img-sec" >
                                                <div className="login_img-body">
                                                    <h5 className="welcome-msg">Welcome  to PechaKucha</h5>
                                                    <p className="Pecha-info">PechaKucha is about presenting about what you love. Anyone can present -- this is the beauty of PechaKucha.</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                {/* <div class="flex-center Forget-password">
                                <p>Forget your password? <a href="/#">Get a new password</a></p>
                            </div> */}
                            </Col>
                            <Col lg={2} md sm />
                            <div className="flex-center Forget-password">
                                <p >Forget your password? <a href={local_routes.sendresetpasswordemail}>Get a new password</a></p>
                            </div>
                        </Row>

                    </div>
                    <Footer />
                </div>
                </React.Fragment>
            );
        }

    }
}

export default Register;